export default "__VITE_ASSET__BtAJBlus__"